'use client';

import React from 'react';
import { ImageBj } from '@components/common';
import bestieImage from '@images/agent/bestie-white-bg.png';

interface BestieAvatarProps {
  isConnected: boolean;
}

/**
 * BestieAvatar
 *
 * Displays the Bestie AI avatar with a pulsating animated effect.
 * When the `isConnected` prop is true, the avatar features an animated pulse background,
 * indicating that an interview is actively in progress.
 *
 * Props:
 *  - isConnected (boolean): Toggle pulsing animation to represent active session.
 *
 */
export const BestieAvatar: React.FC<BestieAvatarProps> = ({
  isConnected,
}) => (
  <div className="flex flex-col items-center space-y-6">
    <div className="relative flex size-48 items-center justify-center">
      {/* Pulsating background - only when connected */}
      {isConnected && (
        <div className="absolute inline-flex size-52 animate-size-pulse rounded-full bg-secondary/15" />
      )}

      <div className="relative flex size-48 items-center justify-center overflow-hidden rounded-full border-2 border-secondary bg-secondary/20 transition-all duration-500">
        <ImageBj
          src={bestieImage}
          alt="Bestie AI"
          width={120}
          height={120}
          className="size-full object-cover"
        />
      </div>
    </div>
  </div>
);

